var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "url(#b)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 226,
    fill: "url(#c)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "M261.163 121.259a9.713 9.713 0 0 0-9.566 0l-10.789 6.106a9.714 9.714 0 0 1-6.189 1.157l-12.266-1.796a9.712 9.712 0 0 0-8.919 3.455l-7.855 9.591a9.712 9.712 0 0 1-5.353 3.315l-12.086 2.756a9.708 9.708 0 0 0-7.069 6.444l-3.86 11.781a9.714 9.714 0 0 1-3.795 5.024l-10.274 6.937a9.71 9.71 0 0 0-4.264 8.562l.657 12.379a9.712 9.712 0 0 1-1.723 6.056l-7.075 10.18a9.71 9.71 0 0 0-.883 9.524l5.084 11.307a9.707 9.707 0 0 1 .581 6.269l-2.92 12.048a9.71 9.71 0 0 0 2.618 9.2l8.825 8.706a9.71 9.71 0 0 1 2.806 5.637l1.63 12.289a9.71 9.71 0 0 0 5.461 7.496l-1.745 5.857c-2.724 9.15-5.455 18.297-8.246 27.426-.838 2.741-1.673 5.483-2.507 8.226-.8 2.635-1.603 5.27-2.416 7.902a934.965 934.965 0 0 0-1.534 5.007c-.236.781-.473 1.563-.711 2.344l-.097.31c-1.381 4.414-2.697 8.62-2.117 13.308 1.36 2.719 3.147 4.756 5.939 5.974 3.405.478 6.037-.124 9.077-1.721l1.094-.599a558.995 558.995 0 0 0 3.662-1.963c.858-.466 1.718-.93 2.578-1.391a651.001 651.001 0 0 0 16.484-9.12l.473-.276c2.755-1.609 5.367-3.134 8.488-3.991a382.498 382.498 0 0 1 4.685 8.577l.65 1.238c1.615 3.069 3.217 6.144 4.802 9.229l1.134 2.205.111.217c.718 1.395 1.436 2.79 2.15 4.188.432.845.857 1.745 1.292 2.667 2.023 4.292 4.271 9.057 8.505 10.939 3.018.433 5.439.388 8.215-.925 3.239-3.002 4.216-5.987 5.379-10.183a736.088 736.088 0 0 1 1.703-6.193l.403-1.442c1.426-5.11 2.912-10.201 4.417-15.288l.768-2.596c1.038-3.51 2.076-7.019 3.119-10.528.634-2.134 1.268-4.268 1.899-6.403l.715-2.418c.715-2.396 1.415-4.781 2.039-7.185a9.728 9.728 0 0 1 3.502-.104c.63 2.439 1.34 4.858 2.066 7.289l.715 2.418c.631 2.135 1.264 4.269 1.899 6.403 1.042 3.509 2.081 7.018 3.119 10.528l.767 2.596a1002.506 1002.506 0 0 1 4.417 15.288l.404 1.442a699.903 699.903 0 0 1 1.702 6.193c1.163 4.196 2.14 7.181 5.38 10.183 2.776 1.313 5.196 1.358 8.215.925 4.234-1.882 6.481-6.647 8.505-10.939.435-.922.86-1.822 1.291-2.667.708-1.386 1.42-2.769 2.132-4.153l.013-.025.116-.227 1.134-2.205a1089.7 1089.7 0 0 1 4.803-9.229l.649-1.238a386.573 386.573 0 0 1 4.685-8.577c3.122.857 5.734 2.382 8.488 3.991l.474.276a652.68 652.68 0 0 0 16.483 9.12c.861.461 1.721.925 2.579 1.391 1.217.66 2.439 1.312 3.662 1.963l1.094.599c3.04 1.597 5.671 2.199 9.076 1.721 2.792-1.218 4.579-3.255 5.939-5.974.581-4.688-.735-8.894-2.117-13.308l-.097-.31-.711-2.344a934.881 934.881 0 0 0-1.533-5.007 1842.61 1842.61 0 0 1-2.417-7.902c-.834-2.743-1.668-5.485-2.506-8.226a3841.606 3841.606 0 0 1-8.246-27.426l-1.378-4.624-.304-1.022.171-.074a9.71 9.71 0 0 0 5.764-7.633l1.63-12.289a9.71 9.71 0 0 1 2.806-5.637l8.825-8.706a9.71 9.71 0 0 0 2.618-9.2l-2.92-12.048a9.707 9.707 0 0 1 .581-6.269l5.084-11.307a9.71 9.71 0 0 0-.883-9.524l-7.075-10.18a9.712 9.712 0 0 1-1.723-6.056l.657-12.379a9.71 9.71 0 0 0-4.264-8.562l-10.274-6.937a9.714 9.714 0 0 1-3.795-5.024l-3.86-11.781a9.708 9.708 0 0 0-7.069-6.444l-12.086-2.756a9.712 9.712 0 0 1-5.353-3.315l-7.855-9.591a9.712 9.712 0 0 0-8.919-3.455l-12.266 1.796a9.714 9.714 0 0 1-6.189-1.157l-10.789-6.106Zm-4.791 131.912a6.164 6.164 0 0 0-2.416.496l-14.964 6.401a6.146 6.146 0 0 1-2.422.504c-3.455-.002-6.49-2.99-6.162-6.806l1.405-16.347a6.295 6.295 0 0 0-1.494-4.642l-10.654-12.392c-3.061-3.561-1.268-9.132 3.282-10.196l15.832-3.703a6.196 6.196 0 0 0 3.911-2.869l8.38-14.059a6.13 6.13 0 0 1 5.306-3.03 6.131 6.131 0 0 1 5.307 3.03l8.379 14.059a6.201 6.201 0 0 0 3.912 2.869l15.832 3.703c4.55 1.064 6.343 6.635 3.281 10.196l-10.653 12.392a6.295 6.295 0 0 0-1.494 4.642l1.405 16.347c.328 3.816-2.707 6.804-6.163 6.806-.797 0-1.616-.16-2.421-.504l-14.964-6.401a6.154 6.154 0 0 0-2.425-.496Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M177.895 282.421c1.528 1.504 2.859 2.999 4.125 4.729 4.601 5.915 11.155 10.513 18.599 11.985 3.237.741 4.442 2.505 6.334 5.123 4.352 5.911 12.104 10.329 19.306 11.733 1.856.014 3.699-.055 5.554-.132 6.71-.262 11.871-.13 17.605 3.521 2.106 1.305 4.093 2.062 6.428 2.87-.825 4.775-2.154 9.37-3.538 14.009l-.715 2.418c-.631 2.135-1.265 4.269-1.899 6.403a7914.185 7914.185 0 0 0-3.119 10.528l-.768 2.596a1025.916 1025.916 0 0 0-4.82 16.73 736.088 736.088 0 0 0-1.703 6.193c-1.163 4.196-2.14 7.181-5.379 10.183-2.776 1.313-5.197 1.358-8.215.925-5.144-2.286-7.356-8.829-9.797-13.607-.75-1.469-1.506-2.936-2.261-4.404l-1.134-2.205c-1.585-3.085-3.187-6.16-4.802-9.229l-.65-1.238a382.498 382.498 0 0 0-4.685-8.577c-3.299.906-6.029 2.559-8.961 4.267a651.001 651.001 0 0 1-16.484 9.12c-.86.461-1.72.925-2.578 1.391-1.218.66-2.439 1.312-3.662 1.963l-1.094.599c-3.04 1.597-5.672 2.199-9.077 1.721-2.792-1.218-4.579-3.255-5.939-5.974-.594-4.797.799-9.091 2.214-13.618.238-.781.475-1.563.711-2.344.507-1.671 1.018-3.34 1.534-5.007.813-2.632 1.616-5.267 2.416-7.902.834-2.743 1.669-5.485 2.507-8.226 2.791-9.129 5.522-18.276 8.246-27.426.752-2.528 1.506-5.055 2.26-7.582l.356-1.195.686-2.297 2.399-8.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M334.328 282.421c-1.528 1.504-2.859 2.999-4.125 4.729-4.601 5.915-11.156 10.513-18.599 11.985-3.237.741-4.442 2.505-6.335 5.123-4.352 5.911-12.104 10.329-19.305 11.733-1.856.014-3.7-.055-5.554-.132-6.71-.262-11.871-.13-17.606 3.521-2.105 1.305-4.092 2.062-6.427 2.87.825 4.775 2.153 9.37 3.538 14.009l.715 2.418c.631 2.135 1.264 4.269 1.899 6.403a9756.296 9756.296 0 0 1 3.886 13.124 1002.506 1002.506 0 0 1 4.417 15.288l.404 1.442a699.903 699.903 0 0 1 1.702 6.193c1.163 4.196 2.14 7.181 5.38 10.183 2.776 1.313 5.196 1.358 8.215.925 5.144-2.286 7.355-8.829 9.796-13.607.751-1.469 1.506-2.936 2.261-4.404l1.134-2.205a1089.7 1089.7 0 0 1 4.803-9.229l.649-1.238a386.573 386.573 0 0 1 4.685-8.577c3.3.906 6.03 2.559 8.962 4.267a652.68 652.68 0 0 0 16.483 9.12c.861.461 1.721.925 2.579 1.391 1.217.66 2.439 1.312 3.662 1.963l1.094.599c3.04 1.597 5.671 2.199 9.076 1.721 2.792-1.218 4.579-3.255 5.939-5.974.594-4.797-.798-9.091-2.214-13.618l-.711-2.344a934.881 934.881 0 0 0-1.533-5.007 1842.61 1842.61 0 0 1-2.417-7.902c-.834-2.743-1.668-5.485-2.506-8.226a3841.606 3841.606 0 0 1-8.246-27.426c-.752-2.528-1.506-5.055-2.26-7.582l-.357-1.195-.685-2.297-2.399-8.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    d: "M261.163 121.259a9.713 9.713 0 0 0-9.566 0l-10.789 6.106a9.714 9.714 0 0 1-6.189 1.157l-12.266-1.796a9.712 9.712 0 0 0-8.919 3.455l-7.855 9.591a9.712 9.712 0 0 1-5.353 3.315l-12.086 2.756a9.708 9.708 0 0 0-7.069 6.444l-3.86 11.781a9.714 9.714 0 0 1-3.795 5.024l-10.274 6.937a9.71 9.71 0 0 0-4.264 8.562l.657 12.379a9.712 9.712 0 0 1-1.723 6.056l-7.075 10.18a9.71 9.71 0 0 0-.883 9.524l5.084 11.307a9.707 9.707 0 0 1 .581 6.269l-2.92 12.048a9.71 9.71 0 0 0 2.618 9.2l8.825 8.706a9.71 9.71 0 0 1 2.806 5.637l1.63 12.289a9.71 9.71 0 0 0 5.764 7.633l11.374 4.93a9.715 9.715 0 0 1 4.653 4.242l5.959 10.871a9.71 9.71 0 0 0 8.133 5.035l12.387.489a9.706 9.706 0 0 1 5.871 2.275l9.483 7.984a9.715 9.715 0 0 0 9.403 1.757l11.727-4.019a9.714 9.714 0 0 1 6.296 0l11.727 4.019a9.715 9.715 0 0 0 9.403-1.757l9.483-7.984a9.706 9.706 0 0 1 5.871-2.275l12.387-.489a9.71 9.71 0 0 0 8.133-5.035l5.959-10.871a9.71 9.71 0 0 1 4.653-4.242l11.374-4.93a9.71 9.71 0 0 0 5.764-7.633l1.63-12.289a9.71 9.71 0 0 1 2.806-5.637l8.825-8.706a9.71 9.71 0 0 0 2.618-9.2l-2.92-12.048a9.707 9.707 0 0 1 .581-6.269l5.084-11.307a9.71 9.71 0 0 0-.883-9.524l-7.075-10.18a9.712 9.712 0 0 1-1.723-6.056l.657-12.379a9.71 9.71 0 0 0-4.264-8.562l-10.274-6.937a9.714 9.714 0 0 1-3.795-5.024l-3.86-11.781a9.708 9.708 0 0 0-7.069-6.444l-12.086-2.756a9.712 9.712 0 0 1-5.353-3.315l-7.855-9.591a9.712 9.712 0 0 0-8.919-3.455l-12.266 1.796a9.714 9.714 0 0 1-6.189-1.157l-10.789-6.106Zm.52 68.299c-2.409-4.04-8.211-4.04-10.619 0l-8.38 14.059a6.201 6.201 0 0 1-3.911 2.87l-15.832 3.702c-4.551 1.064-6.344 6.635-3.282 10.196l10.653 12.392a6.295 6.295 0 0 1 1.494 4.642l-1.405 16.347c-.404 4.698 4.29 8.142 8.591 6.302l14.964-6.401a6.14 6.14 0 0 1 4.834 0l14.964 6.401c4.301 1.84 8.995-1.604 8.591-6.302l-1.405-16.347a6.295 6.295 0 0 1 1.494-4.642l10.653-12.392c3.062-3.561 1.269-9.132-3.281-10.196l-15.832-3.702a6.206 6.206 0 0 1-3.912-2.87l-8.379-14.059Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    d: "M311.918 172.248c-30.338-30.338-79.525-30.338-109.864 0-30.338 30.338-30.338 79.526 0 109.864 30.339 30.338 79.526 30.338 109.864 0 30.339-30.338 30.339-79.526 0-109.864Zm-50.229 17.31c-2.409-4.04-8.21-4.04-10.619 0l-8.38 14.059a6.196 6.196 0 0 1-3.911 2.869l-15.832 3.703c-4.55 1.064-6.343 6.635-3.282 10.196l10.654 12.392a6.295 6.295 0 0 1 1.494 4.642l-1.405 16.347c-.404 4.698 4.29 8.142 8.59 6.302l14.964-6.401a6.142 6.142 0 0 1 4.835 0l14.964 6.401c4.3 1.84 8.994-1.604 8.59-6.302l-1.405-16.347a6.295 6.295 0 0 1 1.494-4.642l10.654-12.392c3.061-3.561 1.268-9.132-3.282-10.196l-15.832-3.703a6.196 6.196 0 0 1-3.911-2.869l-8.38-14.059Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 256,
    x2: 256,
    y1: 0,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F206F",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 304.326,
    x2: 201.15,
    y1: 162.858,
    y2: 284.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 190.884,
    x2: 216.981,
    y1: 383.402,
    y2: 309.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 323.179,
    x2: 357.773,
    y1: 304.503,
    y2: 372.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 149,
    x2: 363.76,
    y1: 226.963,
    y2: 226.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 304.326,
    x2: 201.15,
    y1: 162.858,
    y2: 284.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(90 0 256) scale(226)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F206F",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 262.762,
    height: 320.48,
    x: 125,
    y: 96,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1280_3038",
    stdDeviation: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/claim.58e2fffc3370448f200ff92d97ca22e4.svg";
export { ForwardRef as ReactComponent };